import { Outlet, Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { checkLoginOrNot } from "../helper/custom";
export const ProtectedRouter = () => { 
  return checkLoginOrNot()==false ? <Outlet /> : <Navigate to='/' />
}

export const ProtectedLoginRouter = () => { 
  const location = useLocation();
  return checkLoginOrNot()==true ? <Outlet /> : <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />
}

